import {
    GESTION_OPERATIVA_LICENSE_PLATE_VALIDATED
  } from './constants'
  import validatePatente from '../../common/backend/validatePatente'

  export function validatePatentePeritadoGO(patente) {
    return (dispatch, getState) => {
      if(patente) {
        if (!validatePatente(patente)) {
          const error = 'Ingresá una patente válida'
          dispatch({
            type: GESTION_OPERATIVA_LICENSE_PLATE_VALIDATED,
            data: {
              patenteCodeError: {
                code: 'invalid',
                message: error
              },
              patenteError: error,
              isValidLicensePlate:false
            }
          })
          return false
        }

        const state = getState()
        const existePatente = state.gestionOperativa.sale.Taking_cars.some((item) => item.license_plate.toUpperCase() === patente.toUpperCase())
        if (existePatente) {
          const error ='La patente ya fue cargada'
          dispatch({
            type: GESTION_OPERATIVA_LICENSE_PLATE_VALIDATED,
            data: {
              patenteCodeError: {
                code: 'repeat',
                message: error
              },
              patenteError: error,
              isValidLicensePlate:false
            }
          })
          return false
        }
      } else {
        dispatch({
          type: GESTION_OPERATIVA_LICENSE_PLATE_VALIDATED,
          data: {
            patenteError: 'INGRESE UNA PATENTE',
            isValidLicensePlate:false
          }
        })
        return false
      }

      dispatch({ 
        type: GESTION_OPERATIVA_LICENSE_PLATE_VALIDATED, 
        data: {
          patenteError: '',
          isValidLicensePlate:true
        }
      })
      return true
    }
  }

  export function reducer(state, action) {
    if (action.type === GESTION_OPERATIVA_LICENSE_PLATE_VALIDATED) {
        return {
          ...state,
          ...action.data
        };
    }
    else {
        return state;
    }
  }
